import store from '@/store';
import PaymentProcessorProvider from '@/services/payment/PaymentProcessorProvider';
import PaymentTypes from '@/models/PaymentTypes';
import { IDPaySDK } from '@/helpers/idpaySDK';

export default {
    multiLanguage: null,
    /**
     * Busca a implementação do processor e segue o processamento
     */
    async Process() {
        PaymentProcessorProvider.multiLanguage = this.multiLanguage;

        let paymentType = store.state.payment.PaymentType;
        let processor = PaymentProcessorProvider.GetPaymentProcessor(paymentType);

        const allowedPaymentTypesIdPay = [
            PaymentTypes.CREDIT_CARD,
            PaymentTypes.CLICK_TO_PAY,
            PaymentTypes.GOOGLE_PAY,
            PaymentTypes.APPLE_PAY,
            PaymentTypes.DOF
        ];

        if (allowedPaymentTypesIdPay.includes(paymentType)) {
            try {
                await IDPaySDK.init({
                    type: 'SILENT',
                }).then((collectionId)=>{
                    store.state.cardPayment.idPayDeviceID = collectionId;
                });
            } catch (error) {
                console.error(error, 'Erro ao inicializar o IDPaySDK');
            }
        }

        await processor.ProcessTransaction();
    },
};
